import api from "../api";

export const showTokenService = async () => {
  return await api.get(`/api/v1/token`);
};

export const generateNewTokenService = async () => {
  return await api.post(`/api/v1/token/new`);
};
